/* Full-screen reel player in the VyReel / dearjune.pk style, shared by the homepage reels and the
   product-page video bubble.

   JMPlayer.open(reels, index)
     reels: [{ src, srcMobile, poster, title, price (HTML), url, thumb, cta, action }]
     action 'buy': the button closes the player and takes the visitor to the size picker on this page.

   - The film plays muted with "Tap for sound"; the reels either side peek in (desktop).
   - Arrows, arrow keys or a swipe change reels. Esc, the close button, the backdrop or the phone's Back button close it.
   - While it's open the rest of the page is inert and doesn't scroll. */
(function () {
  if (window.JMPlayer) return;

  var phone = window.matchMedia('(max-width: 749px)');
  var player = null;
  var el = {};
  var reels = [];
  var current = 0;
  var soundOn = false;
  var lastFocus = null;
  var madeInert = [];
  var pushedHistory = false;
  var swiped = false;

  var SVG = {
    close: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.4"></path></svg>',
    prev: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.4"></path></svg>',
    next: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.4"></path></svg>',
    play: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2.5v11l9-5.5z" fill="currentColor"></path></svg>',
    sound: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 6h3l4-3v10L5 10H2z" fill="currentColor"></path><path class="jm-player__wave" d="M11 5.5c1 .8 1 4.2 0 5M12.8 4c1.8 1.6 1.8 6.4 0 8" fill="none" stroke="currentColor" stroke-width="1.1"></path></svg>',
    share: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 10V2M5 5l3-3 3 3M3 8v6h10V8" fill="none" stroke="currentColor" stroke-width="1.2"></path></svg>'
  };

  function build() {
    player = document.createElement('div');
    player.className = 'jm-player';
    player.hidden = true;
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', 'Videos');
    player.innerHTML =
      '<button class="jm-player__close" type="button" data-close aria-label="Close">' + SVG.close + '</button>' +
      '<button class="jm-player__nav jm-player__nav--prev" type="button" data-step="-1" aria-label="Previous video">' + SVG.prev + '</button>' +
      '<button class="jm-player__nav jm-player__nav--next" type="button" data-step="1" aria-label="Next video">' + SVG.next + '</button>' +
      '<div class="jm-player__stage">' +
        '<button class="jm-player__peek" type="button" data-step="-1" tabindex="-1" aria-hidden="true"><img alt=""></button>' +
        '<div class="jm-player__frame">' +
          '<video class="jm-player__video" playsinline loop muted preload="none"></video>' +
          '<button class="jm-player__toggle" type="button" aria-label="Pause"><span class="jm-player__big-play" aria-hidden="true">' + SVG.play + '</span></button>' +
          '<div class="jm-player__progress" aria-hidden="true"><span class="jm-player__bar"></span></div>' +
          '<button class="jm-player__sound" type="button" aria-pressed="false">' + SVG.sound + '<span data-sound-label>Tap for sound</span></button>' +
          '<button class="jm-player__share" type="button" aria-label="Share">' + SVG.share + '<span class="jm-player__toast" data-toast></span></button>' +
          '<p class="jm-player__hint">Swipe up for more</p>' +
          '<div class="jm-player__card">' +
            '<span class="jm-player__thumb"><img alt=""></span>' +
            '<span class="jm-player__info"><span class="jm-player__name"></span><span class="jm-player__price"></span></span>' +
            '<a class="jm-player__cta" href="#">Shop now</a>' +
          '</div>' +
        '</div>' +
        '<button class="jm-player__peek" type="button" data-step="1" tabindex="-1" aria-hidden="true"><img alt=""></button>' +
      '</div>' +
      '<p class="visually-hidden" aria-live="polite" data-status></p>';
    document.body.appendChild(player);

    el.video = player.querySelector('.jm-player__video');
    el.frame = player.querySelector('.jm-player__frame');
    el.bar = player.querySelector('.jm-player__bar');
    el.toggle = player.querySelector('.jm-player__toggle');
    el.sound = player.querySelector('.jm-player__sound');
    el.soundLabel = player.querySelector('[data-sound-label]');
    el.share = player.querySelector('.jm-player__share');
    el.toast = player.querySelector('[data-toast]');
    el.name = player.querySelector('.jm-player__name');
    el.price = player.querySelector('.jm-player__price');
    el.cta = player.querySelector('.jm-player__cta');
    el.thumb = player.querySelector('.jm-player__thumb img');
    el.peeks = player.querySelectorAll('.jm-player__peek');
    el.status = player.querySelector('[data-status]');
    el.close = player.querySelector('.jm-player__close');

    el.video.addEventListener('play', function () {
      player.classList.remove('is-paused');
      el.toggle.setAttribute('aria-label', 'Pause');
    });
    el.video.addEventListener('pause', function () {
      player.classList.add('is-paused');
      el.toggle.setAttribute('aria-label', 'Play');
    });
    el.video.addEventListener('timeupdate', function () {
      if (el.video.duration) el.bar.style.width = (100 * el.video.currentTime / el.video.duration) + '%';
    });

    player.addEventListener('click', function (event) {
      var step = event.target.closest('[data-step]');
      if (step) {
        show(current + Number(step.dataset.step));
        return;
      }
      if (event.target.closest('[data-close]') || event.target === player || event.target.classList.contains('jm-player__stage')) close();
    });

    el.toggle.addEventListener('click', function () {
      if (swiped) return;
      if (el.video.paused) el.video.play();
      else el.video.pause();
    });

    el.sound.addEventListener('click', function () {
      soundOn = !soundOn;
      el.video.muted = !soundOn;
      el.sound.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      el.sound.classList.toggle('is-on', soundOn);
      el.soundLabel.textContent = soundOn ? 'Sound on' : 'Tap for sound';
      if (el.video.paused) el.video.play();
    });

    el.share.addEventListener('click', function () {
      var reel = reels[current];
      var url = new URL(reel.url && reel.url.charAt(0) !== '#' ? reel.url : location.pathname, location.origin).href;
      if (navigator.share) {
        navigator.share({ title: reel.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          el.toast.textContent = 'Link copied';
          el.share.classList.add('is-copied');
          setTimeout(function () { el.share.classList.remove('is-copied'); }, 1600);
        });
      }
    });

    /* On a product page the button takes the visitor to the size picker instead of leaving the page */
    el.cta.addEventListener('click', function (event) {
      var reel = reels[current];
      if (reel.action !== 'buy') return;
      event.preventDefault();
      close();
      /* The size picker specifically (the quantity box also uses .product-form__input and comes first on the page) */
      var target = document.querySelector('variant-selects') || document.querySelector('variant-radios') || document.querySelector('product-form');
      if (!target) return;
      /* Go to the Size row itself: Fabric and Colour usually have a single choice */
      var sizeRow = Array.prototype.filter.call(target.querySelectorAll('fieldset'), function (group) {
        var legend = group.querySelector('legend');
        return legend && /size/i.test(legend.textContent);
      })[0];
      var scope = sizeRow || target;
      scope.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = scope.querySelector('input[type="radio"]:checked:not([disabled])') || scope.querySelector('input:not([disabled]), select, button');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
    });

    document.addEventListener('keydown', function (event) {
      if (!player.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight') show(current + 1);
      else if (event.key === 'ArrowLeft') show(current - 1);
    });

    window.addEventListener('popstate', function () {
      if (player.classList.contains('is-open')) {
        pushedHistory = false;
        close(true);
      }
    });

    /* Phones: swipe up or left for the next reel, down or right for the previous one */
    var startX = 0;
    var startY = 0;
    el.frame.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    el.frame.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 50 || reels.length < 2) return;
      swiped = true;
      setTimeout(function () { swiped = false; }, 400);
      if (Math.abs(dy) > Math.abs(dx)) show(current + (dy < 0 ? 1 : -1));
      else show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function wrap(i) {
    return (i + reels.length) % reels.length;
  }

  function show(i) {
    current = wrap(i);
    var reel = reels[current];
    var video = el.video;
    video.pause();
    video.poster = reel.poster || '';
    video.src = (phone.matches && reel.srcMobile) || reel.src;
    video.muted = !soundOn;
    el.bar.style.width = '0%';
    el.name.textContent = reel.title || '';
    el.price.innerHTML = reel.price || '';
    el.cta.textContent = reel.cta || 'Shop now';
    el.cta.href = reel.url || '#';
    el.thumb.src = reel.thumb || reel.poster || '';
    [-1, 1].forEach(function (step, k) {
      el.peeks[k].querySelector('img').src = reels[wrap(current + step)].poster || '';
    });
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () { player.classList.add('is-paused'); });
    el.status.textContent = (reel.title || 'Video') + (reels.length > 1 ? ', video ' + (current + 1) + ' of ' + reels.length : '');
  }

  function open(list, index) {
    if (!list || !list.length) return;
    if (!player) build();
    reels = list;
    lastFocus = document.activeElement;
    player.classList.toggle('is-single', reels.length < 2);
    player.hidden = false;
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === player || child.tagName === 'SCRIPT' || child.hasAttribute('inert')) return;
      child.setAttribute('inert', '');
      madeInert.push(child);
    });
    document.documentElement.classList.add('jm-player-lock');
    void player.offsetWidth; /* start from the closed state so the fade runs */
    player.classList.add('is-open');
    show(index || 0);
    el.close.focus({ preventScroll: true });
    /* Some browsers drop focus set in the same frame the player appears; set it again once it's drawn */
    setTimeout(function () {
      if (!player.contains(document.activeElement)) el.close.focus({ preventScroll: true });
    }, 60);
    /* The phone's Back button closes the player instead of leaving the page */
    try {
      history.pushState({ jmReel: true }, '');
      pushedHistory = true;
    } catch (e) {}
  }

  function close(fromHistory) {
    if (!player || !player.classList.contains('is-open')) return;
    el.video.pause();
    el.video.removeAttribute('src');
    el.video.load();
    player.classList.remove('is-open');
    madeInert.forEach(function (child) { child.removeAttribute('inert'); });
    madeInert = [];
    document.documentElement.classList.remove('jm-player-lock');
    setTimeout(function () { player.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (pushedHistory && !fromHistory) history.back();
    pushedHistory = false;
  }

  window.JMPlayer = { open: open, close: close };
})();
